import { StrictDict } from '../../utils';

export const RequestStates = StrictDict(
  {
    inactive: 'inactive',
    pending: 'pending',
    completed: 'completed',
    failed: 'failed',
  } as const,
);

export const RequestKeys = StrictDict(
  {
    fetchVideos: 'fetchVideos',
    fetchBlock: 'fetchBlock',
    fetchImages: 'fetchImages',
    fetchUnit: 'fetchUnit',
    fetchStudioView: 'fetchStudioView',
    createBlock: 'createBlock',
    saveBlock: 'saveBlock',
    uploadVideo: 'uploadVideo',
    allowThumbnailUpload: 'allowThumbnailUpload',
    uploadThumbnail: 'uploadThumbnail',
    uploadTranscript: 'uploadTranscript',
    deleteTranscript: 'deleteTranscript',
    fetchCourseDetails: 'fetchCourseDetails',
    updateTranscriptLanguage: 'updateTranscriptLanguage',
    getTranscriptFile: 'getTranscriptFile',
    checkTranscriptsForImport: 'checkTranscriptsForImport',
    importTranscript: 'importTranscript',
    uploadAsset: 'uploadAsset',
    batchUploadAssets: 'batchUploadAssets',
    fetchAdvancedSettings: 'fetchAdvancedSettings',
    fetchVideoFeatures: 'fetchVideoFeatures',
    getHandlerUrl: 'getHandlerUrl',
  } as const,
);
